import { ExternalAccountName } from "./getExternalAccountName";

export const formatExternalAccountName = (
  exAcctNameObj: ExternalAccountName,
  cutOff?: number
) => {
  if (cutOff === undefined) {
    return exAcctNameObj.fullName;
  }

  return exAcctNameObj.name.length > cutOff
    ? `${exAcctNameObj.name.slice(0, cutOff)}... ${exAcctNameObj.mask}`
    : exAcctNameObj.fullName;
};
